export const ROLE_SUPERADMINISTRATOR = { id: 1, name: 'Суперадминистратор' };

export const ROLE_OPERATOR = { id: 2, name: 'Оператор' };

export const ROLE_USER = { id: 3, name: 'Пользователь' };
